"use strict";
import { jsx } from "react/jsx-runtime";
import React from "react";
import Api from "../api/api";
import { push } from "./app_history";
class RootPage extends React.Component {
  componentDidMount() {
    if (Api.Account.current().scraper_account && Api.Account.current().payables_account) {
      push("/dashboard");
    } else if (Api.Account.current().scraper_account) {
      push("/to_be_scraped_loads");
    } else {
      push("/dashboard");
    }
  }
  render() {
    return /* @__PURE__ */ jsx("span", { "data-component": "RootPage" });
  }
}
export default RootPage;
